import { appendIf } from '@btime/helpers'
import { gql, useMutation } from '@apollo/client'
import { useNotification } from '@btime/react-messager'
import { assoc, compose, pick, prop } from 'ramda'

import { qrcodesClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation ActivatedQrcodes($input: ActivatedQrcodesInput) {
    activatedQrcodes(input: $input) {
      id
    }
  }
`

const cleanRequest = compose(
  pick(['type', 'ids', 'bucketName']),
  item => assoc('type', item.type, item),
  item => assoc('ids', prop('ids', item), item),
  item => assoc('bucketName', item.bucketName, item)
)

const validate = (form, setErrors) => {
  const errors = [...appendIf(!form.bucketName, { path: ['bucketName'], message: 'Campo obrigatório' })]

  setErrors(errors)
  return errors.length === 0
}

export const useGenerateActivatedQRCodes = () => {
  const notify = useNotification()
  const closeModal = useCloseModal()

  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['Qrcode', 'Qrcodes'],
    client: qrcodesClient
  })

  const handleRequest = (form, actions) => {
    const { setErrors } = actions

    const input = cleanRequest(form)
    const isValid = validate(form, setErrors)

    const numberOfQRCodes = input?.ids?.length
    const pluralSuffix = numberOfQRCodes > 1 ? 's' : ''

    if (isValid) {
      return request({ variables: { input } }).then(resp => {
        notify.success({ title: `QR Code${pluralSuffix} gerado${pluralSuffix} e ativado${pluralSuffix} com sucesso` })
        if (closeModal) closeModal()
        if (resp.errors) {
          notify.error({ title: `Ocorreu um erro ao gerar e ativar o${pluralSuffix} QR Code${pluralSuffix}` })
        }
      })
    }
  }

  return [handleRequest, state]
}
